/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";

const schema = yup.object().shape({
    dor: yup
        .date()
        .required('Date of registration is required')
        .max(new Date(), 'Date of registration must not future date'),

    full_name: yup
        .string()
        .required('Name is required')
        .min(3, 'Name must be at least 3 characters long'),

    father_name: yup
        .string()
        .required('Father name is required')
        .min(3, 'Father name must be at least 3 characters long'),

    marital_status: yup
        .string()
        .required('Marital status is required'),

    dob: yup
        .date()
        .required('Date of birth is required')
        .max(new Date(), 'Date of birth must not future date'),

    v_fathr_or_husb_name: yup
        .string()
        .min(3, 'Father/Husband Name must be at least 3 characters long'),

    fathr_or_husb_nid: yup
        .string()
        .min(9, 'Father/Husband NID No. must be at least 9 digits')
        .max(20, 'Father/Husband NID No. must be at most 20 digits'),

    national_id: yup
        .string()
        .required('NID No. is required')
        .min(9, 'NID No. must be at least 9 digits')
        .max(20, 'NID No. must be at most 20 digits'),

    contact_phone: yup
        .string()
        .required('Contact Number is required')
        .matches(/^\d{11}$/, 'Phone number must be exactly 11 digits'),

    emergency_contract_ph: yup
        .string()
        .required('Relative Phone number is required')
        .matches(/^\d{11}$/, 'Relative Phone number must be exactly 11 digits'),

    emergency_contract_nm: yup
        .string(),
    // .min(3, 'Relative Name must be at least 3 characters long'),

    contact_contract_relation: yup
        .string()
        .required('Relation with Volunteer is required'),

    active_fg: yup
        .string()
        .required('Active status is required*'),

});

export default schema;